import React from 'react';

const ListColors = ({ colors, action, active }) => {
  return (
    <div className="list-cores">
      {colors.map(({ id, name }) => (
        <button
          className={active === id ? 'active' : ''}
          key={`color_${id}`}
          onClick={() => action(id)}
        >
          {name}
        </button>
      ))}
    </div>
  );
};

export default ListColors;
